// Sumber satu rekod `orders` untuk Rekod Jualan (2026-10-25, arahan user): 'billplz' | 'manual'.
//   • manual  = resit renewal Flow Ultra yang dibayar transfer, direkod admin melalui
//               Extend days → "Paid renewal" (functions/flowResitManual.js, provider 'manual').
//   • billplz = selain itu. Order lama tanpa medan `provider` semuanya Billplz — hanya
//               index.js + promoAiPro.js (provider 'billplz') + flowResitManual.js mencipta orders.
// ⚠️ KEMBAR: peraturan sama dalam functions/flowLangganan.js (bacaSejarah: provider 'manual' ? … : 'billplz').
//    Sumber order baharu (cth gateway lain) → kemas kedua-dua tempat.
// Fungsi TULEN (tiada Firestore) — diuji: node --test src/utils/sumberOrder.test.js

export const SUMBER_LABEL = { all: 'Semua', billplz: 'Billplz', manual: 'Manual' };

export const adalahOrderManual = (o) => o?.provider === 'manual';

export const sumberOrder = (o) => (adalahOrderManual(o) ? 'manual' : 'billplz');

/** sumber: 'all' | 'billplz' | 'manual' */
export const padanSumber = (o, sumber) => !sumber || sumber === 'all' || sumberOrder(o) === sumber;

const msDari = (ts) => {
    if (!ts) return null;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    if (typeof ts.seconds === 'number') return ts.seconds * 1000;
    if (ts instanceof Date) return ts.getTime();
    const n = typeof ts === 'number' ? ts : Date.parse(ts);
    return Number.isFinite(n) ? n : null;
};

/** Sama seperti tapisan server Rekod Jualan: createdAt dalam julat { start, end } (Date | null). range null = semua masa. */
export function dalamJulatTarikh(o, range) {
    if (!range) return true;
    const ms = msDari(o?.createdAt);
    if (ms == null) return false; // query server dengan julat juga menolak doc tanpa createdAt
    if (range.start && ms < range.start.getTime()) return false;
    if (range.end && ms > range.end.getTime()) return false;
    return true;
}

/** { count, sen } order berstatus 'paid'. Jumlah = paidAmountSen (sama seperti aggregation server). */
export function jumlahDibayar(rows) {
    let count = 0, sen = 0;
    for (const o of rows || []) {
        if (o?.status !== 'paid') continue;
        count += 1;
        sen += Number(o.paidAmountSen ?? o.amountSen) || 0;
    }
    return { count, sen };
}

/**
 * Tiga card Rekod Jualan: Semua · Billplz · Manual.
 *   semua  = angka server ({ count, sen } | null bila query gagal)
 *   manual = dikira dari rekod manual ({ count, sen } | null bila gagal dimuat)
 * Billplz = semua − manual. Mana-mana null → Billplz null (card papar "—", bukan angka salah).
 */
export function pecahanSumber(semua, manual) {
    const billplz = semua && manual
        ? { count: Math.max(0, semua.count - manual.count), sen: Math.max(0, semua.sen - manual.sen) }
        : null;
    return { all: semua || null, billplz, manual: manual || null };
}
